import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type BettingInsightsResultAttribute, type EsIndex } from '../types';

import {
	BettingInsightsFilter,
	type BettingInsightsFilterConfiguration,
} from './BettingInsightsFilter';

export interface BettingInsightsRefinementsConfig<TIndex extends EsIndex> {
	clearAll: {
		excludedAttributes: BettingInsightsResultAttribute<TIndex>[];
	};
	components: BettingInsightsFilterConfiguration<TIndex>[];
}

export class BettingInsightsRefinements<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsRefinementsConfig<TIndex>
{
	clearAll: {
		excludedAttributes: BettingInsightsResultAttribute<TIndex>[];
	};
	components: BettingInsightsFilter<TIndex>[];

	constructor({
		clearAll,
		components,
		...requestContext
	}: BettingInsightsRefinementsConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.clearAll = clearAll;
		this.components = components.map(filter =>
			BettingInsightsFilter.withRequestContext<TIndex>(requestContext, filter),
		);
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsRefinementsConfig<TIndex>,
	) {
		return new this<TIndex>({
			...requestContext,
			...config,
		});
	}
}
